import React from "react";

export class StrictErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Switch to fallback mode
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Optional: silently log or send to telemetry
    // console.warn("ErrorBoundary caught:", error);
  }

  componentDidUpdate(prevProps) {
    // ✅ Reset the error boundary when key changes
    if (this.state.hasError && this.props.resetKey !== prevProps.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      // Show custom fallback UI
      return (
        this.props.fallback || (
          <div
            style={{
              width: "100%",
              height: "500px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              color: "#666",
              fontSize: "14px",
            }}
          >
            Content unavailable
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export default StrictErrorBoundary;
